export default __webpack_public_path__ + "static/GRID2022 Stock Conflict RGBlight - Simplify-01-a4c90a4b049c0b7d8a0128bfe2e3486e.svg";